'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MAX_CUSTOM_AVAILABILITY_WEEKS = exports.CUSTOM_AVAILABILITY = exports.DAY_TIME_RANGE = exports.DAY_DURATION = exports.HOUR_DURATION = exports.THIRTY_MINUTE_DURATION = exports.FIFTEEN_MINUTE_MILLIS = exports.TEN_MINUTE_MILLIS = exports.FIFTEEN_MINUTE_DURATION = exports.ZERO_DURATION = exports.ONE_DAY = exports.ONE_HOUR = undefined;

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _TimeRange = require('MeetingsBase/models/TimeRange');

var _TimeRange2 = _interopRequireDefault(_TimeRange);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ONE_HOUR = exports.ONE_HOUR = 3600000;
var ONE_DAY = exports.ONE_DAY = 86400000;
var ZERO_DURATION = exports.ZERO_DURATION = _I18n2.default.moment.duration(0).asMinutes();
var FIFTEEN_MINUTE_DURATION = exports.FIFTEEN_MINUTE_DURATION = _I18n2.default.moment.duration({ minutes: 15 }).asMinutes();
var TEN_MINUTE_MILLIS = exports.TEN_MINUTE_MILLIS = _I18n2.default.moment.duration({ minutes: 10 }).asMilliseconds();
var FIFTEEN_MINUTE_MILLIS = exports.FIFTEEN_MINUTE_MILLIS = _I18n2.default.moment.duration({ minutes: 15 }).asMilliseconds();
var THIRTY_MINUTE_DURATION = exports.THIRTY_MINUTE_DURATION = _I18n2.default.moment.duration({ minutes: 30 }).asMinutes();
var HOUR_DURATION = exports.HOUR_DURATION = _I18n2.default.moment.duration({ minutes: 60 }).asMinutes();
var DAY_DURATION = exports.DAY_DURATION = _I18n2.default.moment.duration({ hours: 24 }).asMinutes();

var DAY_TIME_RANGE = exports.DAY_TIME_RANGE = _TimeRange2.default.from({
  start: ZERO_DURATION,
  end: DAY_DURATION
});

// The value to store for weeksToAdvertise when using custom availability.
// (weeksToAdvertise requires an integer value)
var CUSTOM_AVAILABILITY = exports.CUSTOM_AVAILABILITY = 0;

var MAX_CUSTOM_AVAILABILITY_WEEKS = exports.MAX_CUSTOM_AVAILABILITY_WEEKS = 10;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/MeetingsBase/target/src/MeetingsBase/static-1.2449/js/constants/dates.js
// module id = 49
// module chunks = 0